export default class FormatCurrency {
    static convertIntegerToCurrencyFormat(amount: number | undefined): string {
        return amount ? (amount / 100).toFixed(2) : '0';
    }

    static mapCurrencyToSymbol(currency: string | undefined): string {
        const currencyToSymbol = {
            AUD: '$',
            USD: '$',
            EUR: '€',
            GBP: '£'
        };
        return currency ? currencyToSymbol[currency] || '' : '';
    }
}
